<template>
    <div class="energy-config-main">

        <div class="energy-config-left">

            <el-container>
                <el-main ref="elMain" style="height: calc(100vh - 10rem);width: 100%;">
                    <el-tree
                            class="filter-tree"
                            :data="tree"
                            :props="defaultProps"
                            node-key="id"
                            :filter-node-method="filterNode"
                            :default-expanded-keys="expandedKeys"
                            v-loading="loading"
                            @node-click="click"
                            :expand-on-click-node="false"
                            :indent="fontSize"
                            highlight-current

                    >
                    </el-tree>
                    <center>
                        <el-button v-if="(tree ===null || tree.length === 0) && !loading" @click="selectEnergyUnit">刷新
                        </el-button>
                    </center>
                </el-main>
            </el-container>

        </div>
        <div class="div-hr-h"></div>
        <div class="energy-config-right" :disabled="loading">

            <!--口径设置中显示-->
            <div class="energy-config-condition-box">
                <div v-if="visible.approach && this.visibleType === 3">
                    <el-button slot="reference" type="primary" size="small"
                               @click="ok('energyUnitDialogForm')" :disabled="loading">添加子区域
                    </el-button>
                </div>
                <!--能耗单元设置中显示-->
                <div v-if="visible.energy">
                    <el-button slot="reference" type="primary" size="small"
                               @click="ok('nodeDialogForm')" :disabled="loading">添加子节点
                    </el-button>
                    <el-button slot="reference" type="primary" size="small"
                               @click="selectUser" v-loading="buttonLoading" :disabled="loading">添加业主用户
                    </el-button>
                    <el-button size="small" icon="el-icon-delete" type="text" @click="deleteEnergyUtil"
                               style="color: #F56C6C">删除节点
                    </el-button>
                </div>

                <div v-if="visible.customer">
                    <el-button slot="reference" type="primary" size="small"
                               @click="deleteCustomerEnergyUtil" v-loading="buttonLoading" :disabled="loading">删除业主用户
                    </el-button>
                    <el-button type="primary" size="small" @click="energyUnitSort">排序</el-button>
                </div>

            </div>

            <div class="content-form" v-if="!visible.customer && !visible.meter">

                <el-form :model="form" size="small" :rules="myRules" ref="energyUnitForm">
                    <el-row>
                        <el-col :span="8">
                            <!--在口径设置中出现-->
                            <el-form-item label="口径名称" :label-width="formLabelWidth" v-if="visible.approach">
                                <el-input v-model="form.name" auto-complete="on" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <!--在能耗单元设置中出现-->
                        <el-col :span="8">
                            <el-form-item label="口径名称" :label-width="formLabelWidth" v-if="visible.energy">
                                <el-input v-model="form.approachName" auto-complete="on"
                                          :disabled="visible.energy" :maxlength="inputMaxLength"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <!--在能耗单元设置中出现-->
                            <el-form-item label="区域名称" :label-width="formLabelWidth" v-if="visible.energy"
                                          prop="name">
                                <el-input v-model="form.name" auto-complete="on"
                                          :maxlength="inputMaxLength"
                                          @blur="form.name = form.name.replace(/\s/g,'')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <!--在能耗单元设置中出现-->
                            <el-form-item label="代 码" :label-width="formLabelWidth" v-if="visible.energy"
                                          prop="code">
                                <el-input v-model="form.code" auto-complete="on"
                                          :maxlength="inputMaxLength"
                                          @blur="form.code = form.code.replace(/\s/g,'')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <!--均出现-->
                            <el-form-item label="启用状态" :label-width="formLabelWidth" prop="enabled">
                                <el-select v-model="form.enabled" placeholder="启用状态" :disabled="visible.approach">
                                    <el-option label="启用" :value="1"></el-option>
                                    <el-option label="停用" :value="0"></el-option>
                                </el-select>
                            </el-form-item>

                        </el-col>
                        <el-col :span="8" v-if="visible.energy">
                            <el-form-item label="排列顺序" :label-width="formLabelWidth" prop="order">
                                <el-input-number v-model="form.order" :min="0" :max="1000"
                                                 :disabled="visible.approach"></el-input-number>
                            </el-form-item>


                        </el-col>

                    </el-row>
                    <el-row>
                        <!--均出现-->
                        <el-col :span="8" v-if="visible.approach">
                            <el-form-item label="启用状态" :label-width="formLabelWidth" prop="enabled">
                                <el-select v-model="form.enabled" placeholder="启用状态" :disabled="visible.approach">
                                    <el-option label="启用" :value="1"></el-option>
                                    <el-option label="停用" :value="0"></el-option>
                                </el-select>
                            </el-form-item>


                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <!--在口径设置中出现-->
                            <el-form-item label="口径类型" :label-width="formLabelWidth" v-if="visible.approach"
                                          prop="type">
                                <el-select v-model="form.type" placeholder="请选择" :disabled="visible.approach">
                                    <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <!--均出现-->
                        <el-col :span="8" v-if="visible.approach">
                            <el-form-item label="备注" :label-width="formLabelWidth">
                                <el-input
                                        :disabled="visible.approach"
                                        type="textarea"
                                        placeholder="请输入内容"
                                        v-model="form.note" :maxlength="noteMaxLength">
                                </el-input>

                            </el-form-item>
                        </el-col>
                        <el-col :span="16" v-if="visible.energy">
                            <el-form-item label="备注" :label-width="formLabelWidth">
                                <el-input
                                        :disabled="visible.approach"
                                        type="textarea"
                                        placeholder="请输入内容"
                                        v-model="form.note" :maxlength="noteMaxLength">
                                </el-input>

                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="16">
                            <el-form-item style="float: right;">
                                <el-button type="primary" @click="submitForm('energyUnitForm')"
                                           :disabled="loading"
                                           v-if="!visible.approach">
                                    保 存
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>

            </div>

            <div class="content-user" v-if="visible.user">
                <flex>

                    <el-table size="small" :data="customer"
                              height="100%"
                              width="100%"
                              stripe
                              highlight-current-row
                              :header-row-style="{color:'black'}"
                              @row-click="">

                        <el-table-column
                                align="center"
                                prop="realName"
                                label="业主用户名称"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="name"
                                :formatter="tableStringFormat"
                                label="业主用户编号">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="contactPerson"
                                :formatter="tableStringFormat"
                                label="联系人">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="mobile"
                                label="手机"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="email"
                                label="电子邮箱"
                                :formatter="tableStringFormat">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                prop="alarmReceivingMode"
                                label="报警接收方式"
                                :formatter="alarmReceivingModeFormat">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                prop="enabled"
                                label="启用状态"
                                :formatter="enabledFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="createDate"
                                label="创建日期"
                                :formatter="tableTimeFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="deadline"
                                label="有效截止日期"
                                :formatter="tableTimeFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="address"
                                label="用户地址"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="note"
                                label="备注"
                                :formatter="tableStringFormat">
                        </el-table-column>
                    </el-table>
                </flex>

                <div class="energy-config-pagination" v-if="visible.user">

                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 30, 50, 100]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="pageTotal"
                            align="center">
                    </el-pagination>

                </div>

            </div>
            <div class="content-customer" v-if="visible.customer">
                <flex>
                    <el-table
                            :data="customer"
                            :header-row-style="{color:'black'}"
                            stripe
                            id="out-table"
                            :cell-style="{padding:'0.5'}"
                            size="small"
                            height="100%"
                            width="100%"
                            :highlight-current-row="customerUserflag"
                            @row-click="currClick">
                    >
                        <el-table-column
                                align="center"
                                prop="realName"
                                label="业主用户名称"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="name"
                                :formatter="tableStringFormat"
                                label="业主用户编号">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="contactPerson"
                                :formatter="tableStringFormat"
                                label="联系人">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="mobile"
                                label="手机"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="email"
                                label="电子邮箱"
                                :formatter="tableStringFormat">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                prop="alarmReceivingMode"
                                label="报警接收方式"
                                :formatter="alarmReceivingModeFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="createDate"
                                label="创建日期"
                                :formatter="tableTimeFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="deadline"
                                label="有效截止日期"

                                :formatter="tableTimeFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="address"
                                label="用户地址"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="note"
                                label="备注"
                                :formatter="tableStringFormat">
                        </el-table-column>
                    </el-table>
                </flex>
            </div>
            <div class="content-meter" v-if="visible.customer">
                <flex>
                    <el-table
                            height="100%"
                            width="100%"
                            :data="meter"
                            stripe
                            :cell-style="{padding:'0.5'}"
                            :header-row-style="{color:'black'}"
                            size="small"
                            :highlight-current-row="meterflag"
                            @row-click="currClick">
                    >
                        <el-table-column
                                align="center"
                                prop="name"
                                label="仪表名称"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="code"
                                label="仪表编号"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterNum"
                                label="表号"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="icon"
                                label="图标">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterTypeName"
                                label="仪表型号"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="energyType"
                                label="能源类型"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="address"
                                label="安装位置"
                                :formatter="tableStringFormat">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                label="备注"
                                prop="note"
                                :formatter="tableStringFormat">
                        </el-table-column>


                    </el-table>
                </flex>

                <div class="energy-config-pagination" v-if="visible.customer">

                    <el-pagination
                            background
                            @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 30, 50, 100]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="pageTotal"
                            align="center">
                    </el-pagination>

                </div>

            </div>
            <!--</div>-->
        </div>
        <el-dialog title="添加子区域" :visible.sync="visible.energyDialog" width="40%"
                   @close="closeDialog('energyUnitDialogForm')"><!--添加能耗单元弹窗-->
            <el-form :model="energyUnitDialogForm" size="small" :rules="myRules" ref="energyUnitDialogForm"
            >

                <el-row>
                    <!--均出现-->
                    <el-col :span="11">
                        <el-form-item label="区域名称" :label-width="formLabelWidth">
                            <el-input v-model="energyUnitDialogForm.aName" auto-complete="on" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="子区域名称" :label-width="formLabelWidth"
                                      prop="name">
                            <el-input v-model="energyUnitDialogForm.name" auto-complete="off"
                                      :maxlength="inputMaxLength"
                                      @blur="energyUnitDialogForm.name = energyUnitDialogForm.name.replace(/\s/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <!--均出现-->
                    <el-col :span="11">
                        <el-form-item label="代 码" :label-width="formLabelWidth" prop="code">
                            <el-input v-model="energyUnitDialogForm.code" auto-complete="off"
                                      :maxlength="inputMaxLength"
                                      @blur="energyUnitDialogForm.code = energyUnitDialogForm.code.replace(/\s/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">


                        <el-form-item label="排列顺序" :label-width="formLabelWidth" prop="order">
                            <!--<el-input v-model="energyUnitDialogForm.order" auto-complete="off"
                                      :maxlength="inputMaxLength"></el-input>-->
                            <el-input-number v-model="energyUnitDialogForm.order" :min="0"
                                             :max="1000"></el-input-number>

                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <!--均出现-->
                    <el-col :span="11">

                        <el-form-item label="启用状态" :label-width="formLabelWidth" prop="enabled">
                            <el-select v-model="energyUnitDialogForm.enabled" placeholder="启用状态">
                                <el-option label="启用" :value="1"></el-option>
                                <el-option label="停用" :value="0"></el-option>
                            </el-select>
                        </el-form-item>

                    </el-col>
                </el-row>
                <el-row>
                    <!--均出现-->
                    <el-col :span="22">
                        <el-form-item label="备注" :label-width="formLabelWidth">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入内容"
                                    v-model="energyUnitDialogForm.note" :maxlength="noteMaxLength">
                            </el-input>

                        </el-form-item>
                    </el-col>

                </el-row>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible.energyDialog = false" size="small">取 消</el-button>
                <el-button type="primary" size="small" @click="submitForm('energyUnitDialogForm')" v-loading="loading">保
                    存
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加子节点" :visible.sync="visible.nodeDialog" width="40%"
                   @close="closeDialog('nodeDialogForm')"><!--添加子节点-->
            <el-form :model="energyUnitDialogForm" size="small" :rules="myRules" ref="nodeDialogForm">
                <el-row>
                    <!--在能耗单元设置中出现-->
                    <el-col :span="15">
                        <el-form-item label="口径名称" :label-width="formLabelWidth">
                            <el-input v-model="energyUnitDialogForm.approachName" auto-complete="on"
                                      disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!--均出现-->
                    <el-col :span="15">
                        <el-form-item label="区域名称" :label-width="formLabelWidth">
                            <el-input v-model="energyUnitDialogForm.aName" auto-complete="on" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <!--在能耗单元设置中出现,在添加业主用户中不出现-->
                    <el-col :span="15">
                        <el-form-item label="节点名称" :label-width="formLabelWidth" prop="name">
                            <el-input v-model="energyUnitDialogForm.name" auto-complete="off"
                                      :maxlength="inputMaxLength"
                                      @blur="energyUnitDialogForm.name = energyUnitDialogForm.name.replace(/\s/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <!--均出现-->
                    <el-col :span="15">
                        <el-form-item label="排列顺序" :label-width="formLabelWidth" prop="order">
                            <!--<el-input v-model="energyUnitDialogForm.order" auto-complete="off"
                                      :maxlength="inputMaxLength" @blur="energyUnitDialogForm.order = energyUnitDialogForm.order.replace(/\s/g,'')"></el-input>-->
                            <el-input-number style="width: 41%" v-model="energyUnitDialogForm.order" :min="0"
                                             :max="1000"></el-input-number>

                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!--均出现-->
                    <el-col :span="15">
                        <el-form-item label="启用状态" :label-width="formLabelWidth" prop="enabled">
                            <el-select v-model="energyUnitDialogForm.enabled" placeholder="启用状态">
                                <el-option label="启用" :value="1"></el-option>
                                <el-option label="停用" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <!--均出现-->
                    <el-col :span="15">
                        <el-form-item label="备注" :label-width="formLabelWidth">
                            <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入内容"
                                    v-model="energyUnitDialogForm.note" :maxlength="noteMaxLength">
                            </el-input>

                        </el-form-item>
                    </el-col>

                </el-row>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible.nodeDialog = false" size="small">取 消</el-button>
                <el-button type="primary" size="small" @click="submitForm('nodeDialogForm')" v-loading="loading">保 存
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加业主用户" :visible.sync="visible.customerDialog" width="40%"
                   v-if="visible.customerDialog"
                   @close="closeDialog('customerDialogForm')"><!--添加业主用户-->

            <el-form :model="energyUnitDialogForm" size="small" :rules="myRules" ref="customerDialogForm"
            >
                <el-form-item prop="customerUserIds" style="text-align: center">
                    <el-transfer v-model="energyUnitDialogForm.customerUserIds" :data="user"
                                 :button-texts="['撤回至', '添加至']" style="text-align: left; display: inline-block"
                                 :titles="['选择业主用户', '添加列表']"
                                 :props="{key: 'id',label: 'realName'}">
                    </el-transfer>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible.customerDialog = false" size="small">取 消</el-button>
                <el-button type="primary" size="small" @click="submitForm('customerDialogForm')" :disabled="loading">保 存
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="能耗单元排序" :visible.sync="visible.energyUnitSortDialog" width="40%" size="small">
            <div v-if="sortTarget != null">
                请输入序号：<el-input v-model="sortTarget.order" size="small" width="50%"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible.energyUnitSortDialog = false" size="small">取消</el-button>
                <el-button type="primary" @click="saveEnergyUnitSort(sortTarget.order)" size="small">保存</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
  /* eslint-disable spaced-comment */

  import {
    insertEnergyUnit,
    selectCustomerUser,
    selectCustomerUserByUid,
    deleteCustomerEnergyUtil,
    insertCustomerUserEnergyUnit,
    deleteEnergyUtil,
    saveEnergyUnit
  } from '@/api/EnergyUnit'
  import {insertApproach, getApproach} from '@/api/Approach'
  import {queryCustomerById} from '@/api/customerUser'
  import {selectCustomerUserMeter} from '@/api/CustomerUserMeter'
  import {selectMeterById, saveMeter} from '@/api/Meter'
  import {tree, expandedCustomer} from '@/utils/energyUtilTree'
  import {checkNum} from '@/utils/validate'
  import {mapGetters} from 'vuex'
  import Flex from "../../../../components/Flex"
  import {getStartAndEnd, formatDate, format} from '@/utils/time'

  export default {
    name: 'meterManage',
    components: {
      'flex': Flex
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val)
      }
    },
    computed: {
      ...mapGetters([
        'fontSize',
        'customerId'
      ])
    },
    mounted() {
      this.visibleType = 4
      /*this.elMainStyle.height = parseInt(this.$refs.elMain.$el.clientHeight) * 0.95 + 'px'*/
      this.tree = []
      this.typeName = '添加口径'
      this.selectEnergyUnit()
    },
    methods: {
      saveEnergyUnitSort: function(val){
        var reg = /^[0-9]\d*$/
        if(reg.test(val)){
          if (this.currSelectRow.hasOwnProperty("password")) {
            //业主用户能耗单元
            saveEnergyUnit(this.sortTarget).then(response => {
              this.visible.energyUnitSortDialog = false
              if(response.code == 200){
                this.$message({
                  message: '操作成功!',
                  type: 'success',
                  duration: 5 * 1000
                })
              }else{
                this.$message({
                  message: '操作失败!',
                  type: 'error',
                  duration: 5 * 1000
                })
              }
              this.selectEnergyUnit()
              //this.click(this.node)
            })
          }else{
            //仪表
            const energyUnit = {customerId: this.sortTarget.customerId, code: this.sortTarget.code, order: this.sortTarget.order, typeId: this.sortTarget.id}
            saveMeter(this.sortTarget).then(response => {
              this.visible.energyUnitSortDialog = false
              if(response.code == 200){
                //业主用户能耗单元
                saveEnergyUnit(energyUnit).then(response => {
                  this.visible.energyUnitSortDialog = false
                  this.click(this.node)
                  if (response.code == 200) {
                    this.$message({
                      message: '操作成功!',
                      type: 'success',
                      duration: 5 * 1000
                    })
                  } else {
                    this.$message({
                      message: '操作失败!',
                      type: 'error',
                      duration: 5 * 1000
                    })
                  }
                })
              }else{
                this.$message({
                  message: '操作失败!',
                  type: 'error',
                  duration: 5 * 1000
                })
              }
            })
          }
        }else {
          this.$message({
            message: '请输入合理的序号!',
            type: 'warning',
            duration: 5 * 1000
          })
        }
      },
      currClick: function(val) {
        this.currSelectRow = Object.assign({}, val)
        if (this.currSelectRow.hasOwnProperty("password")) {
          //业主用户
          this.customerUserflag = true
          this.meterflag = false
        }else{
          //仪表
          this.customerUserflag = false
          this.meterflag = true
        }
      },
      energyUnitSort: function(){
        if (this.currSelectRow != null) {
          this.visible.energyUnitSortDialog = true
          if (this.currSelectRow.hasOwnProperty("password")) {
            //业主用户
            this.sortTarget = this.form
          }else{
            //仪表
            this.sortTarget = this.currSelectRow
          }
        }else{
          this.$message({
            message: '请选择排序对象!',
            type: 'warning',
            duration: 5 * 1000
          })
        }
      },
      deleteEnergyUtil() {
        if (this.form.id === undefined || this.form.id === null || this.form.id === '') return
        this.$confirm('此操作将永久删除该节点以及其子节点, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteEnergyUtil({energyUnitId: this.form.id, customerId: this.customerId}).then(response => {
            if (response.code === 200 && response.infoJson === 1) {
              this.$message({
                message: '子节点删除成功',
                type: 'success',
                duration: 5 * 1000
              })
              this.selectEnergyUnit()
            }
            else if (response.code === 200 && response.infoJson === -1) {
              this.$message({
                message: '该节点下包含业主用户,请先删除业主用户!',
                type: 'warning',
                duration: 5 * 1000
              })

            }
            else {
              this.$message({
                message: '删除失败!',
                type: 'error',
                duration: 5 * 1000
              })
            }
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '删除失败!',
              type: 'error',
              duration: 5 * 1000
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })

      },
      deleteCustomerEnergyUtil() {
        this.$confirm('此操作将永久删除该业主用户以及其仪表信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteCustomerEnergyUtil({energyUnitId: this.form.id, customerId: this.customerId}).then(response => {
            if (response.code === 200 && response.infoJson) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
            this.selectEnergyUnit()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      resetForm(formName) { /* 移除表单检验结果*/
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields()
        }
      }, defaultExpandedKeys(data) {
        if (data === null || data === undefined) return
        if (data !== null) if (data[0] === null) return

        this.expandedKeys.push(data[0].id)
        if (data[0].children === null || data[0].children === undefined) return
        this.defaultExpandedKeys(data[0].children)
      },
      click(data, node) { /* 树点击事件 */
        /* treeGrade  0:能耗单元 1:业主用户能耗单元 2:仪表能耗单元 3:口径修改 4.口径添加*/
        if (data != {}) {
          this.node = data
          if (data.treeGrade === 4) { /* 添加口径*/
            return
          } else if (data.treeGrade === 3) { /* 修改口径信息*/
            this.resetForm('energyUnitForm')
            this.energyUnitDialogForm = {
              id: '',
              name: '',
              enabled: '',
              note: '',
              code: '',
              grade: '',
              order: '',
              approachId: '',
              aName: '',
              parentId: '',
              approachName: '',
              meterUnitType: '',
              typeId: '',
              father: {},
              customerUserIds: []
            }
            this.form = {
              id: '',
              name: '',
              type: '',
              enabled: '',
              note: '',
              treeGrade: '',
              customerId: '',
              order: '',
              code: '',
              approachName: '',
              father: {
                id: '',
                name: '',
                enabled: '',
                note: '',
                grade: '',
                order: '',
                approachId: '',
                aName: '',
                parentId: '',
                approachName: '',
                father: {}
              }
            }
            this.visible.approach = true
            this.visible.user = false
            this.visible.energy = false
            this.visible.meter = false
            this.visible.customer = false

            this.typeName = '能耗单元'

            this.visibleType = data.treeGrade

            this.form.id = data.id
            this.form.type = data.type
            this.form.approachName = data.label
            this.form.note = data.note
            this.form.name = data.label
            this.form.treeGrade = data.treeGrade
            this.form.order = data.order
            this.form.enabled = data.enabled

            this.energyUnitDialogForm.approachName = data.label
            this.energyUnitDialogForm.approachId = data.id
            this.energyUnitDialogForm.aName = data.label
            this.energyUnitDialogForm.parentId = data.id
            this.energyUnitDialogForm.treeGrade = data.treeGrade

            return
          } else if (data.treeGrade === 0) { /*能耗单元*/
            this.resetForm('energyUnitForm')
            this.energyUnitDialogForm = {
              id: '',
              name: '',
              enabled: '',
              note: '',
              code: '',
              grade: '',
              order: '',
              approachId: '',
              aName: '',
              parentId: '',
              approachName: '',
              meterUnitType: '',
              typeId: '',
              father: {},
              customerUserIds: []
            }
            this.form = {
              id: '',
              name: '',
              type: '',
              enabled: '',
              note: '',
              treeGrade: '',
              customerId: '',
              order: '',
              code: '',
              approachName: '',
              father: {
                id: '',
                name: '',
                enabled: '',
                note: '',
                grade: '',
                order: '',
                approachId: '',
                aName: '',
                parentId: '',
                approachName: '',
                father: {}
              }
            }
            this.visible.approach = false
            this.visible.customer = false
            this.visible.meter = false

            this.$nextTick(() => {
              this.visible.energy = true
              this.visible.user = true
            })

            this.typeName = '区域设置'

            this.visibleType = data.treeGrade

            this.form.name = data.label
            this.form.id = data.id
            this.form.father = data.father
            this.form.type = data.type
            this.form.note = data.note
            this.form.enabled = data.enabled
            this.form.customerId = data.customerId
            this.form.order = data.order
            this.form.treeGrade = data.treeGrade
            this.form.approachName = data.approachName
            this.form.approachId = data.approachId
            this.form.code = data.code

            this.energyUnitDialogForm.approachId = data.approachId
            this.energyUnitDialogForm.treeGrade = data.treeGrade
            this.energyUnitDialogForm.approachName = data.approachName
            this.energyUnitDialogForm.parentId = data.id
            this.energyUnitDialogForm.aName = data.label
            this.energyUnitDialogForm.grade = data.grade
            this.energyUnitDialogForm.father = data
            this.energyUnitDialogForm.type = data.type
            this.currentPage = 1
            this.selectCustomerUserByUid(data.id)
          } else if (data.treeGrade === 1) { /* 业主用户能耗单元*/
            this.resetForm('energyUnitForm')
            /* this.cleanData(this.energyUnitDialogForm)
             this.cleanData(this.form)*/
            this.energyUnitDialogForm = {
              id: '',
              name: '',
              enabled: '',
              note: '',
              code: '',
              grade: '',
              order: '',
              approachId: '',
              aName: '',
              parentId: '',
              approachName: '',
              meterUnitType: '',
              typeId: '',
              father: {},
              customerUserIds: []
            }
            this.form = {
              id: '',
              name: '',
              type: '',
              enabled: '',
              note: '',
              treeGrade: '',
              customerId: '',
              order: '',
              code: '',
              approachName: '',
              father: {
                id: '',
                name: '',
                enabled: '',
                note: '',
                grade: '',
                order: '',
                approachId: '',
                aName: '',
                parentId: '',
                approachName: '',
                father: {}
              }
            }
            this.visible.approach = false
            this.visible.user = false
            this.visible.energy = false
            this.visible.meter = false

            this.$nextTick(() => {
              this.visible.customer = true
            })


            this.typeName = '业主用户'

            this.visibleType = data.treeGrade

            this.form.name = data.label
            this.form.id = data.id
            this.form.father = data.father
            this.form.type = data.type
            this.form.typeId = data.typeId
            this.form.note = data.note
            this.form.enabled = data.enabled
            this.form.customerId = data.customerId
            this.form.order = data.order
            this.form.approachName = data.approachName
            this.form.approachId = data.approachId
            this.form.code = data.code
            this.currentPage = 1
            queryCustomerById(data.typeId).then(response => {
              this.customer = []
              this.customer.push(response.infoJson)
            }).catch(error => {
              console.log(error)
            })
            selectCustomerUserMeter(data.typeId).then(response => {
              const customerUserMeter = response.infoJson
              this.meterData = customerUserMeter
              this.meter = this.searchByPage(customerUserMeter)
            }).catch(error => {
              console.log(error)
            })
          } else if (data.treeGrade === 2) { /* 仪表能耗单元 */
            this.visible.user = false
            this.visible.meter = true
            this.visible.customer = false
            selectMeterById(data.id).then(response => {
              this.meter = []
              this.meter.push(response.infoJson[0])
            }).catch(error => {
              console.log(error)
            })
          }
        }
      },
      ok(val) {
        this.resetForm(val)
        if (val === 'customerDialogForm') this.visible.customerDialog = true
        else if (val === 'nodeDialogForm') this.visible.nodeDialog = true
        else if (val === 'energyUnitDialogForm') this.visible.energyDialog = true
      },
      insertEnergyUnit(formName) {
        this.loading = true
        this.energyUnitDialogForm.grade = 0
        /*口径下第一级为0*/
        this.energyUnitDialogForm.customerUserIds = []
        //清除父级的子级
        this.energyUnitDialogForm.father.children = []
        insertEnergyUnit(this.energyUnitDialogForm).then(reponse => {
          if (reponse.code === 200 && reponse.infoJson === true) this.success()
          else this.fail()
          this.tree = []
          this.selectEnergyUnit()
          this.loading = false
          if (formName === 'customerDialogForm') this.visible.customerDialog = false
          else if (formName === 'nodeDialogForm') this.visible.nodeDialog = false
          else if (formName === 'energyUnitDialogForm') this.visible.energyDialog = false
        }).catch(error => {
          this.loading = false
          this.fail()
          console.log(error)
        })
      },
      updateEnergyUnit() { /* 更新能耗单元*/
        this.loading = true
        insertEnergyUnit(this.form).then(response => {
          this.tree = []
          this.selectEnergyUnit()
          this.loading = false
          this.visible.energyDialog = false
          this.success()
        }).catch(error => {
          this.loading = false
          console.log(error)
        })
      },
      insertCustomerUserEnergyUnit() {
        let energyUnit = this.energyUnitDialogForm
        //清除父级的子级
        energyUnit.father.children = []
        insertCustomerUserEnergyUnit(energyUnit).then(response => {
          if (response.code === 200 && response.infoJson === true) {
            this.$message({
              type: 'success',
              message: '添加业主用户成功!'
            })
          }
          else {
            this.$message({
              type: 'error',
              message: '添加业主用户失败!'
            })
          }
          this.tree = []
          this.selectEnergyUnit()
          this.loading = false
          this.visible.customerDialog = false
        }).catch(error => {
          this.visible.customerDialog = false
          this.loading = false
          this.fail()
          console.log(error)
        })
      },
      saveOrUpdateApproach() { /* 添加或更新口径信息*/
        this.loading = true
        this.form.customerId = this.$store.getters.customerId
        insertApproach(this.form).then(() => {
          this.tree = []
          this.selectEnergyUnit()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.loading = true
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '操作失败!'
          })
          console.log(error)
        })
      },
      /* 表格间距 */
      cellPadding() {
        return 'padding:0'
      },
      userName(val) { /* 通过id获取name*/
        this.energyUnitDialogForm.name = this.user.find((item) => {
          return item.id === val
        }).name
      },
      handleSelectionChange(val) { /* 树变化 */
        this.multipleSelection = val
      },
      filterNode(value, data) { /*data.id + ''转字符串,number类型报错*/
        if (!value) return true
        const id = (data.id + '').indexOf(value)
        const label = data.label.indexOf(value)
        return (id !== -1 || label !== -1)
      },
      selectUser() { /* 查询用户*/
        this.buttonLoading = true

        this.energyUnitDialogForm.meterUnitType = 0
        this.energyUnitDialogForm.type = 1

        selectCustomerUser(this.form.approachId, this.$store.getters.customerId).then(response => {
          this.buttonLoading = false
          this.user = []
          const data = response.infoJson

          /*for(let i in data)  this.user.push({key:data[i].id,label:data[i].name})*/
          this.user = Object.assign([], data)
          this.ids = []
          this.visible.customerDialog = true
          this.ok('customerDialogForm')
        }).catch(error => {
          this.buttonLoading = false
          console.log(error)
        })
      },
      searchByPage(data) {
        /* 数据总个数dataTotal, pageTotal总页数, 每页个数pagesize, 当前页数currentPage*/
        const dataTotal = data.length
        this.pageTotal = dataTotal
        const start = ((this.currentPage - 1) * this.pageSize)
        const end = this.currentPage * this.pageSize
        return data.slice(start, end)
      },
      selectCustomerUserByUid(id) { /* 查询用户*/
        selectCustomerUserByUid(id).then(response => {
          this.customer = []
          const data = response.infoJson
          this.customerData = data
          this.customer = this.searchByPage(data);
        }).catch(error => {
          console.log(error)
        })
      },
      closeDialog(formName) { /* 关闭弹窗,清除指定数据*/
        this.energyUnitDialogForm.type = 0
        this.energyUnitDialogForm.name = ''
      },

      submitForm(formName) { /* 表单验证*/
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (formName === 'energyUnitForm'){
              this.updateEnergyUnit()
            } else if (formName === 'energyUnitDialogForm' || formName === 'nodeDialogForm') {
              this.energyUnitDialogForm.parentId = this.energyUnitDialogForm.father.id
              if (formName === 'energyUnitDialogForm') {
                this.energyUnitDialogForm.parentId = 'no'
                this.energyUnitDialogForm.type = 0
                this.energyUnitDialogForm.meterUnitType = 0
              } else if (formName === 'nodeDialogForm') {
                this.energyUnitDialogForm.type = 0
                this.energyUnitDialogForm.meterUnitType = 0
                this.energyUnitDialogForm.meterUnitType = 0
              }
              this.energyUnitDialogForm.customerId = this.$store.getters.customerId
              this.insertEnergyUnit(formName)
            } else if (formName === 'customerDialogForm') {
              this.energyUnitDialogForm.customerId = this.$store.getters.customerId
              this.insertCustomerUserEnergyUnit()
            }
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      selectEnergyUnit() {
        this.resetForm('energyUnitForm')
        /*this.cleanData(this.form)*/
        /*this.cleanData(this.energyUnitDialogForm)*/
        this.energyUnitDialogForm = {
          id: '',
          name: '',
          enabled: '',
          note: '',
          code: '',
          grade: '',
          order: '',
          approachId: '',
          aName: '',
          parentId: '',
          approachName: '',
          meterUnitType: '',
          typeId: '',
          father: {},
          customerUserIds: []
        }
        this.form = {
          id: '',
          name: '',
          type: '',
          enabled: '',
          note: '',
          treeGrade: '',
          customerId: '',
          order: '',
          code: '',
          approachName: '',
          father: {
            id: '',
            name: '',
            enabled: '',
            note: '',
            grade: '',
            order: '',
            approachId: '',
            aName: '',
            parentId: '',
            approachName: '',
            father: {}
          }
        }
        this.loading = true
        const customerId = this.$store.getters.customerId
        const ids = []
        getApproach(customerId,'building').then(response => {
          if(response.code === 200)
          {
            let id = response.infoJson.id
            ids.push(id)
            tree(customerId, ids, 2, null, null).then(response => {
              if (response !== null || response !== undefined) {
                this.tree = response
                this.expandedKeys = []
                this.expandedKeys.push(expandedCustomer(this.tree))
                const data = this.tree[0].children[0]
                this.typeName = '能耗单元'

                this.visibleType = data.treeGrade

                this.form.id = data.id
                this.form.type = data.type
                this.form.approachName = data.label
                this.form.note = data.note
                this.form.name = data.label
                this.form.treeGrade = data.treeGrade
                this.form.order = data.order
                this.form.enabled = data.enabled

                this.energyUnitDialogForm.approachName = data.label
                this.energyUnitDialogForm.approachId = data.id
                this.energyUnitDialogForm.aName = data.label
                this.energyUnitDialogForm.parentId = data.id
                this.energyUnitDialogForm.treeGrade = data.treeGrade
              }
              this.loading = false
              this.visible.approach = true
              this.visible.user = false
              this.visible.energy = false
              this.visible.meter = false
              this.visible.customer = false
            }).catch(error => {
              this.$message({
                type: 'error',
                message: '能耗单元树查询失败'
              })
              this.loading = false
              console.log(error)
            })
          }

        }).catch(error => {
          this.$message({
            type: 'error',
            message: '能耗单元树查询失败'
          })
          this.loading = false
          console.log(error)
        })
      }, getChild(child, father, name) { /* 子节点*/
        if (child == null || child.length === 0) return
        const children = []
        for (let j = 0; j < child.length; j++) {
          children.push(
            {
              treeGrade: child[j].type,
              id: child[j].id,
              label: child[j].name,
              grade: child[j].grade,
              enabled: child[j].enabled,
              order: child[j].order,
              customerId: child[j].customerId,
              note: child[j].note,
              code: child[j].code,
              approachId: child[j].approachId,
              approachName: name,
              father: father,
              children: this.getChild(child[j].children, child[j], name)
            }
          )
        }
        return children
      },
      success() { /* 成功提示*/
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, fail() { /* 失败提示*/
        this.$message({
          type: 'error',
          message: '操作失败!'
        })
      },
      cleanData(data) {
        for (const i in data) data[i] = ''
      },
      handleSizeChange(size) { /* 改变条数*/
        this.pageSize = size
        this.customer = this.searchByPage(this.customerData)
      },
      handleCurrentChange(currentPage) { /* 改变页数*/
        this.currentPage = currentPage
        this.customer = this.searchByPage(this.customerData)
      },
      handleSizeChange2(size) { /* 改变条数*/
        this.pageSize = size
        this.meter = this.searchByPage(this.meterData)
      },
      handleCurrentChange2(currentPage) { /* 改变页数*/
        this.currentPage = currentPage
        this.meter = this.searchByPage(this.meterData)
      },
      tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      }, alarmReceivingModeFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if (cellValue + '' === '0') return '不接收'
          else if (cellValue + '' === '1') return '短信'
          else if (cellValue + '' === '2') return '邮件'
          else if (cellValue + '' === '3') return '短信+邮件'
        }
        return '--'
      }, enabledFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          if (cellValue + '' === '0') return '不启用'
          else if (cellValue + '' === '1') return '启用'
        }
        return '--'
      }, tableTimeFormat(row, column, cellValue) { // 表格中时间格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return format(cellValue, 'YYYY-MM-DD')
        }
        return '--'
      }, labelHead(h, {column, index}) {
        const l = column.label.length
        const f = 20 // 每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
        column.minWidth = f * l // 字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
        // 然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
        return h('div', {class: 'table-head', style: {width: '100%'}}, [column.label])
      }
    },
    data() {
      return {
        elMainStyle: {
          height: '',
          width: ''
        }, page: {
          size: 10
        },
        expandedKeys: [],
        visible: {
          user: false, /* 能耗单元下业主用户显示相关*/
          customer: false, /* 业主用户显示相关*/
          meter: false, /* 仪表显示相关*/
          approach: true, /* 口径显示相关*/
          energy: false, /* 能耗单元显示相关*/
          nodeDialog: false, /* 子节点弹窗显示相关*/
          energyDialog: false, /* 能耗单元弹窗显示相关*/
          customerDialog: false, /* 业主用户弹窗显示相关*/
          energyUnitSortDialog: false
        },
        myRules: {
          /* 正则*/
          approachName: [
            {required: true, message: '仪表名称不能为空', trigger: 'change'}
          ],
          aName: [
            {required: true, message: '请填写能耗单元名称', trigger: 'change'}
          ],
          enabled: [
            {required: true, message: '请选择是否启用', trigger: 'change'}
          ],
          order: [
            {required: true, message: '请填写排列顺序', trigger: 'change'},
            {validator: checkNum, trigger: 'change'}
          ],
          id: [
            {required: true, message: '请填写编号标号', trigger: 'change'}
          ],
          type: [
            {required: true, message: '请选择区域类型', trigger: 'change'}
          ],
          name: [
            {required: true, message: '请填写口径名称', trigger: 'change'},
            {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'change'}
          ],
          meterId: [
            {required: true, message: '请选择要添加的仪表', trigger: 'change'}
          ],
          typeId: [
            {required: true, message: '请选择要添加的业主用户', trigger: 'change'}
          ],
          customerUserIds: [{required: true, message: '请选择要添加的用户', trigger: 'blur'}],
          code: [{required: true, message: '请填写代码', trigger: 'blur'}, {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'change'
          }],
          note: [{min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'change'}]
        },
        input: '',
        typeName: '', /* 弹窗标题*/
        filterText: '', /* 树搜索*/
        tree: [], /* 树*/
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        enableMeter: [], /* 启用未使用的仪表*/
        customer: [],
        customerData: [],
        meterData: [],
        currentPage: 1,
        pageSize: 10,
        pageTotal: 1,
        loading: false, /* 加载*/
        multipleSelection: '',
        form: {
          id: '',
          name: '',
          type: '',
          enabled: '',
          note: '',
          treeGrade: '',
          customerId: '',
          order: '',
          code: '',
          approachName: '',
          father: {
            id: '',
            name: '',
            enabled: '',
            note: '',
            grade: '',
            order: '',
            approachId: '',
            aName: '',
            parentId: '',
            approachName: '',
            father: {}
          }
        },
        buttonLoading: false,
        user: [],
        energyUnitDialogForm: {
          id: '',
          name: '',
          enabled: '',
          note: '',
          code: '',
          grade: '',
          order: '',
          approachId: '',
          aName: '',
          parentId: '',
          approachName: '',
          meterUnitType: '',
          typeId: '',
          father: {},
          customerUserIds: []
        },
        customerUserflag: false,
        meterflag: false,
        currSelectRow: null,
        sortTarget: null,
        energyUnitUser: [],
        customerMeterForm: {
          id: '',
          meterId: '',
          customerUserId: ''
        },
        meter: [],
        formLabelWidth: '7rem',
        options: [
          {value: 'area', label: '区域'},
          {value: 'building', label: '楼宇'}
        ],
        visibleType: ''/* 0:添加口径 1:修改口径 2:添加能耗单元 3:添加子能耗单元*/,
        inputMaxLength: 51,
        noteMaxLength: 201,
        node: {},//树的选中节点
      }
    }
  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">


    .energy-config-main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        font-size: 10px;
        button {
            /*font-size: 14px;*/
            font-weight: bold;

        }

        .energy-config-left {
            width: 13vw;
            display: flex;
            flex-direction: column;
            /*.el-main {
                padding: 0;
            }*/
            .el-tree {
                background-color: #fafafa;
                min-width: 100%;
                display: inline-block !important;
            }
        }
        .div-hr-h {
            height: 100%;
            width: 0.02rem;
            background-color: #dedede;
        }
        .energy-config-right {
            height: 100%;
            width: calc(100% - 13vw - 0.02rem);
            box-sizing: border-box;
            padding-left: 1rem;
            align-items: center;
            .energy-config-condition-box {
                align-items: center;

                padding-top: 0.5rem;
                box-sizing: border-box;
                height: 50px;
                /* button {
                     height: 2.5rem;
                 }*/

            }
            /*.el-form-item {
                margin-bottom: 1.2rem;
            }*/
            .content-form {
                padding-top: 0.5rem;
                height: 37vh;
                width: 100%;
                .content-table {
                    width: 100%;
                }

            }
            .content-user {
                align-items: center;
                display: flex;
                height: calc(63vh - 13.2rem);
                flex-direction: column;
                padding-top: 0.5rem;
                width: 100%;
            }
            .content-customer {
                align-items: center;
                padding-top: 0.5rem;
                flex-direction: column;
                height: 20vh;
                width: 100%;
                display: flex
            }
            .content-meter {
                height: calc(80vh - 13.2rem);
                padding-top: 0.5rem;
                flex-direction: column;
                /*height: calc(65vh - 13rem);*/
                width: 100%;
                display: flex
            }
            .energy-config-pagination {
                width: 100%;
                height: 2rem;
                align-items: center;
            }
            .content-customer-form {
                width: 100%;
                padding-top: 0.5rem;
                height: 20vh;
            }
        }

    }

    .el-textarea__inner {
        min-height: 0rem;
    }

    .table-head {
        font-size: 1rem !important; //设置固定的字体大小
    }
</style>
